import React from 'react';
import './FooterServices.css';
import { FaFacebook, FaInstagram, FaWhatsapp, FaMicrochip } from 'react-icons/fa';

const FooterServices = () => {
    return (
        <footer className='footer-services'>
            <div className='footer-services-content'>
                {/* Logo */}
                <div className='footer-services-logo-container'>
                    <img src="/images/logo_Services.png" alt="Volteon Services Logo" className="footer-services-logo" />
                    <div className="services-badge-footer">
                        <FaMicrochip className="services-icon-footer" />
                        <span className="services-text-footer">SERVICES</span>
                    </div>
                </div>

                {/* Texto principal */}
                <p className='footer-services-text'>
                    En Volteon Services, transformamos tus proyectos técnicos en realidad, con diseños <br />
                    electrónicos profesionales y servicios especializados
                </p>

                {/* Enlaces en una fila */}
                <ul className='footer-services-links'>
                    <li><a href='/envios'>Información de envíos</a></li>
                    <li><a href='/reembolso'>Política de reembolso</a></li>
                    <li><a href='/PuntosdeVenta'>Puntos de venta</a></li>
                </ul>

                {/* Teléfono */}
                <p className='footer-services-phone'>Teléfono: +506 6386-5580</p>

                {/* Iconos de redes sociales */}
                <div className='footer-services-icons'>
                    <a
                        href="https://www.facebook.com/volteonelectronics"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaFacebook className='icon-services' />
                    </a>

                    <a
                        href="https://www.instagram.com/volteon_electronics"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaInstagram className='icon-services' />
                    </a>

                    <a
                        href="https://wa.me/50663865580"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaWhatsapp className='icon-services' />
                    </a>
                </div>

                {/* Derechos reservados */}
                <p className='footer-services-rights'>All rights reserved, 2025</p>
            </div>
        </footer>
    );
};

export default FooterServices;